import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    package: {},
    isLoadingPackage: false
  },
  getters: {
    getPackage: (state) => state.package,
    getIsLoadingPackage: (state) => state.isLoadingPackage
  },
  mutations: {
    reset (state) {
      state.package = {}
    },
    setPackage (state, payload) {
      state.package = payload
    },
    toggleLoadingPackage (state) {
      state.isLoadingPackage = !state.isLoadingPackage
    }
  },
  actions: {
    async fetchPackage ({ commit }, id) {
      commit('toggleLoadingPackage')
      const response = await new ApiService(`${id}`).getResults()
      commit('setPackage', response)
      commit('toggleLoadingPackage')
    }
  }
}
